import emit from '../../common/events';
import store from '../../store/store';
import { BusinessUnit } from '../checkout/shop-checkout.interface';
import { SHARPEN_PROGRAM_ID } from './constants/sharpen-page-type.constants';
import { StoreState } from '../../store/store.interface';
import { SubscriptionProductData } from '../subscription/add-to-cart/subscription-add-to-cart';
import {
  determineBusinessUnit,
  getBaseTitle,
  getProductTypeBU,
  getProductTypeInfo,
  getSearchTermObjectFromCartLocalStorage,
  getSecondLevelBU,
  getTitleWithDuration,
} from '../../common/utils/analytics-util';
import { getUserDataForUserAnalytics } from '../user-profile/user-profile.selectors';

export class SharpenUpsellAnalytics {
  static trackUpsellProduct({
    element,
    name,
    eventName,
    id,
    businessUnit,
    storeCategory,
    programId,
    upsellProduct,
    additionalData,
  }: {
    element: any;
    name: string;
    eventName: string;
    id?: string;
    businessUnit: string;
    storeCategory?: string;
    programId: string;
    upsellProduct: SubscriptionProductData;
    additionalData: any;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element: element,
      name: name,
      detail: JSON.parse(
        JSON.stringify({
          id: id,
          eventName: eventName,
          store: storeCategory,
          url: window.location.href,
          isbn: upsellProduct.isbn,
          isbn13: upsellProduct.isbn13,
          title: upsellProduct.productTitle,
          seoTitle: upsellProduct.seoTitle,
          description: upsellProduct.description,
          price: upsellProduct.listPrice,
          offerPricingId: upsellProduct.offerPricingId,
          isEdoms: !!upsellProduct.offerPricingId,
          quantity: 1,
          duration: upsellProduct.duration,
          durationPeriod: upsellProduct.durationPeriod,
          user: getUserDataForUserAnalytics(state),
          businessUnit: businessUnit,
          copyrightYear: upsellProduct.copyrightYear,
          publishDate: upsellProduct.publishDate,
          contributors: upsellProduct.contributors,
          availability: upsellProduct.availability,
          instructorComp: upsellProduct.instructorComp,
          isMaster: upsellProduct.isMaster,
          productOrdered: 'purchasable',
          ...getProductTypeBU({
            programIds: [programId],
          }),
          ...getSecondLevelBU({
            programId: programId,
          }),
          ...getProductTypeInfo({
            programId: programId,
          }),
          ...additionalData,
          ...getSearchTermObjectFromCartLocalStorage({
            programId: programId ?? '',
            showRemoveLink: false,
          }),
          ...getTitleWithDuration({
            title:
              getBaseTitle({
                product: {},
                state,
                productTitle: upsellProduct.title ?? upsellProduct.productTitle ?? '',
                edition: upsellProduct.edition,
                isEvergreenProduct: upsellProduct.everGreenProduct,
                programSourceId: programId,
              }) ?? '',
            duration: Number(upsellProduct.duration!),
            durationPeriod: upsellProduct.durationPeriod!,
            isHeDigitalProduct: true,
          }),
        })
      ),
      dataLayer: true,
    });
  }

  static viewFrequentlyBoughWith({
    element,
    pageType,
    upsellProduct,
    additionalData,
  }: {
    element: any;
    pageType: string;
    upsellProduct: SubscriptionProductData;
    additionalData: any;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element: element,
      name: 'view-frequently-bought-with',
      detail: {
        url: window.location.href,
        isbn: upsellProduct?.isbn,
        isbn13: upsellProduct?.isbn13,
        title: upsellProduct?.productTitle,
        seoTitle: upsellProduct?.seoTitle,
        description: upsellProduct?.description,
        user: getUserDataForUserAnalytics(state, true),
        businessUnit: determineBusinessUnit(BusinessUnit.HE),
        copyrightYear: upsellProduct?.copyrightYear,
        publishDate: upsellProduct?.publishDate,
        contributors: upsellProduct?.contributors,
        availability: upsellProduct?.availability,
        instructorComp: upsellProduct?.instructorComp,
        isMaster: upsellProduct?.isMaster,
        productOrdered: 'purchasable',
        pageType: pageType?.toLowerCase(),
        ...getProductTypeInfo({ programId: SHARPEN_PROGRAM_ID }),
        ...additionalData,
      },
      dataLayer: true,
    });
  }
}
